import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function PreventiveMaintenancePage() {
  const [rows, setRows] = useState([]);
  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine: "",
    schedule_date: "",
    description: "",
    cost: "",
    completed: false
  });

  useEffect(() => {
    fetchMaintenance();
    fetchMachines();
  }, []);

  const fetchMaintenance = () => {
    axios.get(baseUrl + "preventive-maintenance/")
      .then(res => setRows(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch maintenance records", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/")
      .then(res => setMachines(res.data))
      .catch(() => Swal.fire("Error", "Could not fetch machines", "error"));
  };

  const inputHandler = (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setData({ ...data, [e.target.name]: value });
  };

  const formSubmit = () => {
    if (!data.machine || !data.schedule_date || !data.cost) {
      Swal.fire("Error", "All fields except completed are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("machine", data.machine);
    _formData.append("description", data.description);
    _formData.append("schedule_date", data.schedule_date);
    _formData.append("cost", data.cost);
    _formData.append("completed", data.completed);
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "preventive-maintenance/", _formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(res => {
        Swal.fire({ title: "Maintenance Added", icon: "success", timer: 2000, showConfirmButton: false });
        setData({ machine: "", description: "", schedule_date: "", cost: "", completed: false });
        fetchMaintenance();
      })
      .catch(() => Swal.fire("Error", "Something went wrong", "error"));
  };

  const handleDelete = (id) => {
    Swal.fire({ title: "Confirm", text: "Are you sure?", icon: "warning", showCancelButton: true, confirmButtonText: "Yes" })
      .then(result => {
        if (result.isConfirmed) {
          axios.delete(baseUrl + "preventive-maintenance/" + id + "/")
            .then(() => { Swal.fire("Deleted", "Maintenance deleted", "success"); fetchMaintenance(); });
        }
      });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    { field: "machine", headerName: "Machine", width: 150, renderCell: (params) => params.row.machine?.name || "Unknown" },
    { field: "description", headerName: "Description", flex: 2 },
    { field: "schedule_date", headerName: "Scheduled Date", width: 150 },
    { field: "cost", headerName: "Cost", width: 150 },
    { field: "completed", headerName: "Completed", width: 150, renderCell: (params) => params.row.completed ? "Yes" : "No" },
    {
      field: "edit", headerName: "Edit", renderCell: (params) => (
        <Link to={`/preventive-maintenance/edit/${params.row.id}`} target="_blank" className="btn btn-warning btn-sm">Edit</Link>
      ), width: 120
    },
    {
      field: "delete", headerName: "Delete", renderCell: (params) => (
        <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm">Delete</button>
      ), width: 120
    }
  ];

  return (
    <div className="container mt-4">
      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Preventive Maintenance</h4>

        <select name="machine" value={data.machine} onChange={inputHandler} className="form-control mt-3">
          <option value="">Select Machine</option>
          {machines.map((m) => <option key={m.id} value={m.id}>{m.name}</option>)}
        </select>
     <textarea
          className="form-control mt-3"
          placeholder="Description"
          name="description"
          value={data.description}
          onChange={inputHandler}
        />

        <input type="date" className="form-control mt-3" name="schedule_date" value={data.schedule_date} onChange={inputHandler} />
        <input type="number" className="form-control mt-3" placeholder="Cost" name="cost" value={data.cost} onChange={inputHandler} />
        <div className="form-check mt-3">
          <input type="checkbox" className="form-check-input" name="completed" checked={data.completed} onChange={inputHandler} />
          <label className="form-check-label">Completed</label>
        </div>

        <button className="btn btn-success mt-3" onClick={formSubmit}>Submit</button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid rows={rows} columns={columns} pageSize={10} autoHeight components={{ Toolbar: GridToolbar }}
          sx={{ boxShadow: 4, border: 4, borderColor: "primary.light", "& .MuiDataGrid-cell:hover": { color: "primary.main" } }}
        />
      </div>
    </div>
  );
}

export default PreventiveMaintenancePage;
